module.exports = __webpack_public_path__ + "img/396fbde168a65030e878effad7354ae5.png";


//////////////////
// WEBPACK FOOTER
// ./src/scripts/lib/images/finance_logo3.png
// module id = 911
// module chunks = 5